export default "__VITE_ASSET__702bb58f__"